var XPortal = XPortal || {};
XPortal.BooleanEditor =
{
    ControlSelector: ".xpand-boolean",
    Init: function (container) {
        var self = this;
        container = container ? container : $(XPortal.Main.DetialFormSelector);
        container.find(self.ControlSelector).each(function () {
            self.initFor(XPortal.Store.getModelName(container[0].id), this);
        });
    },
    initFor: function (modelName, domEl, isInlineEditor = false) {
        var el = $(domEl);
        const sttgs = XPortal.Main.GetSettingsFor(el);
        el.on("change", function () {
            let value = el.prop("checked") === true ? "1" : "0";
            XPortal.DefaultEditor.SetModification(el, value);
            if (!isInlineEditor) el.trigger("dispatchFieldEvent");            
        });

        if (isInlineEditor && el) $(el).attr("data-skip", "");

        el.bind("dispatchFieldEvent", function (e) {
            let value = el.prop("checked") === true ? "1" : "0";

            XPortal.Store.FieldEvent(el[0], value, modelName, sttgs);
            $("<span class='k-dirty'/>").prependTo(el.closest("td"));
        });

        XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el },
            (data) => {
                const isChecked = data === "1" || data === true || data === "True" || data === 1;
                const newValue = isChecked ? "1" : "0";
                const currentValue = el.prop("checked") ? "1" : "0";
                if (XPortal.DefaultEditor.IsModified(el, currentValue)) return;
                if (el) {
                    if (el.prop("checked") !== isChecked) el.prop("checked", isChecked);
                    if (el.val() !== newValue) el.val(newValue);
                    XPortal.DefaultEditor.SetModification(el, newValue);
                }
            },
            (data) => el.prop("checked") ? "1" : "0"
        );
    }
};